module.exports = __webpack_public_path__ + "static/media/exhibition-services-img15.e251919d.jpg";